import { AgentsSmsPage } from 'app/components/agents-hub/AgentPages'

export const handle = {
  title: `Agents · SMS`,
  breadcrumb: `SMS`,
}

export default function AgentsSMSRoute() {
  return <AgentsSmsPage />
}
